export const removeLineBreak = (text: string): string => {
    if (text===undefined) return text;
    return text.replace(/(\r\n|\n|\r)/gm, "");
}

export const isEditingText = (e: any) => {
    if ((e.target as Element).nodeName === 'INPUT') return true;
    if ((e.target as Element).nodeName === 'DIV' && (e.target as HTMLDivElement).isContentEditable) return true;
    if ((e.target as Element).nodeName === 'SPAN' && (e.target as HTMLSpanElement).isContentEditable) return true;
    return false;
}
